import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import Header from '../../Components/Header';
import { Spinner } from 'react-bootstrap';
import { BASE_URL, paybridge_Url } from '../../Config';

const Sales_Testing = () => {
  const [agentId, setAgentId] = useState('');
  const [agentName, setAgentName] = useState('');
  const [CustomerName, setCustomerName] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [cnic, setCnic] = useState('');
  const [status, setStatus] = useState('Completed');
  const [gender, setGender] = useState('');
  const [packageId, setPackageId] = useState('');
  const [Remarks, setRemarks] = useState('');
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [companyId, setCompanyId] = useState('');
  const [companyName, setCompanyName] = useState('');

  useEffect(() => {
    const storedUserData = sessionStorage.getItem('user');
    if (!storedUserData) return;

    const parsedData = JSON.parse(storedUserData);

    setAgentId(parsedData.userId);
    setAgentName(parsedData.name);
    setCompanyId(parsedData.companyId || 'COMP001');
    setCompanyName(parsedData.companyName || 'Default Company');

    console.log("companyId :", companyId);

    axios.get(`${BASE_URL}RetailAgentGetPackage?id=${parsedData.userId}`)
      .then(response => {
        if (response.data.responseCode === '0000') {
          setPackages(response.data.packages);
        } else {
          Swal.fire('Error', 'Failed to load packages.', 'error');
        }
      })
      .catch(() => {
        Swal.fire('Error', 'An error occurred while fetching packages.', 'error');
      });
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = [];
    if (!CustomerName) errors.push('Name is required.');
    if (!mobileNo) errors.push('Mobile Number is required.');
    if (!gender) errors.push('Gender is required.');
    if (!packageId) errors.push('Package is required.');

    if (errors.length > 0) {
      Swal.fire('Error', errors.join('\n'), 'error');
      return;
    }

    const selectedPackage = packages.find(
      pkg => pkg.packageid === parseInt(packageId)
    );

    const amount = selectedPackage?.packagePrice || 0;
    const productCode = selectedPackage?.packageProductcode || "NDEFUTFZDAILYPRE1MPRE";

    setLoading(true);

    try {
      const response = await axios.post(
        `${paybridge_Url}payment/Payment_generateJCPaymentUrl`,
        {
          agentId: agentId,
          companyId: companyId,
          amount: amount,
          msisdn: Number(mobileNo), 
          productCode: productCode 
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      );

      setLoading(false);

      if (response.data?.success) {
        const paymentUrl = response.data?.data?.paymentUrl || response.data?.url;

        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Payment URL generated successfully. Click OK for Next Sale.',
          confirmButtonText: 'OK'
        }).then(() => {
          window.location.reload();
        });

      } else {
        Swal.fire('Error', response.data?.message || 'Failed to generate payment URL', 'error');
      }

    } catch (error) {
      setLoading(false);

      Swal.fire(
        'Error',
        error.response?.data?.message || error.message || 'API error',
        'error'
      );
    }
  };


  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const errors = [];
  //   if (!CustomerName) errors.push('Name is required.');
  //   if (!mobileNo) errors.push('Mobile Number is required.');
  //   // if (!cnic) errors.push('CNIC is required.');
  //   if (!gender) errors.push('Gender is required.');
  //   if (!packageId) errors.push('Package is required.');

  //   if (errors.length > 0) {
  //     Swal.fire('Error', errors.join('\n'), 'error');
  //     return;
  //   }

  //   const selectedPackage = packages.find(pkg => pkg.packageid === parseInt(packageId));
  //   const amount = selectedPackage?.packagePrice || 0;

  //   setLoading(true);
  //   try {
  //     const response = await axios.post(
  //       `${paybridge_Url}payment/pay`,
  //       {
  //         amount,
  //         mobile: mobileNo,
  //         cnic: cnic || null,
  //         CustomerName: CustomerName || null,
  //         Remarks: Remarks || null,
  //         agent_Name: agentName,
  //         agent_id: agentId,
  //         company_id: companyId,
  //         company_Name: companyName,
  //       },
  //       { headers: { 'Content-Type': 'application/json' } }
  //     );

  //     setLoading(false);

  //     if (response.data.success) {
  //       const resData = response.data.data;
  //       // ✅ Special handling for already subscribed
  //       if (response.data.status === 'ALREADY_SUBSCRIBED') {
  //         Swal.fire({
  //           icon: 'warning',
  //           title: 'Already Subscribed',
  //           text: response.data.message || 'Customer already subscribed within 365 days.',
  //         });
  //         return;
  //       }

  //       // ✅ Normal payment completed
  //       Swal.fire({
  //         icon: 'success',
  //         title: `Payment Status: ${response.data.status || 'Completed'}`,
  //         text: response.data.message || 'Payment processed successfully.',
  //       }).then(() => {
  //         window.location.reload(); // Refresh the page if needed
  //       });

  //     } else {
  //       Swal.fire('Error', response.data.message || 'Payment failed.', 'error');
  //     }

  //   } catch (error) {
  //     setLoading(false);
  //     Swal.fire('Error', error.response?.data?.message || 'An error occurred while processing payment.', 'error');
  //   }
  // };

  return (
    <>
      <Header />
      <div className="container-fluid d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
        <div className="row justify-content-center w-100">
          <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4 col-xxxl-3">
            <div className="card shadow-sm">
              <div className="card-body">

                <div className="text-center mb-4">
                  <h4>Testing Register Customer</h4>
                </div>

                <form onSubmit={handleSubmit}>
                  {/* NAME + MOBILE */}
                  <div className="row mb-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter full name"
                        value={CustomerName}
                        onChange={(e) => setCustomerName(e.target.value)}
                      />
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Mobile No</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="e.g. 03001234567"
                        value={mobileNo}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,11}$/.test(value)) {
                            setMobileNo(value);
                          }
                        }}
                      // onChange={(e) => {
                      //   const value = e.target.value;
                      //   if (/^\d{0,11}$/.test(value)) {
                      //     if (value.length <= 2) setMobileNo('03'.slice(0, value.length));
                      //     else if (value.startsWith('03')) setMobileNo(value);
                      //   }
                      // }}
                      />
                    </div>
                  </div>

                  {/* CNIC + GENDER */}
                  <div className="row mb-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label">CNIC</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter 6 digit CNIC"
                        value={cnic}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d{0,6}$/.test(value)) setCnic(value);
                        }}
                      />
                    </div>

                    <div className="col-12 col-md-6">
                      <label className="form-label">Gender</label>
                      <select
                        className="form-select"
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>

                  {/* PACKAGE */}
                  <div className="row mb-3">
                    <div className="col-12">
                      <label className="form-label">Package</label>
                      <select
                        className="form-select"
                        value={packageId}
                        onChange={(e) => setPackageId(e.target.value)}
                      >
                        <option value="">Select Package</option>
                        {packages.map(pkg => (
                          <option key={pkg.packageid} value={pkg.packageid}>
                            {pkg.packageName} - Rs.{pkg.packagePrice}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* REMARKS */}
                  <div className="mb-3">
                    <label className="form-label">Remarks</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Enter remarks (optional details)"
                      value={Remarks}
                      onChange={(e) => setRemarks(e.target.value)}
                    />
                  </div>

                  {/* SUBMIT BUTTON */}
                  <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                    {loading ? <><Spinner size="sm" /> Processing...</> : 'Pay & Register'}
                  </button>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sales_Testing;